module.exports = __webpack_public_path__ + "static/media/dice-d4.744758d6.svg";